<template>
  <vs-popup
    classContent="popup-example"
    title="Select Event"
    :active.sync="show"
  >
    <div>
      <vs-input class="w-full" placeholder="search event" v-model="filter" />
      <b-table
        ref="table"
        style="height: 600px;"
        thead-class="hidden_header"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :filter="filter"
        :selectable="false"
        :items="e_upcoming_list"
        :select-mode="`multi`"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        @row-clicked="myRowClickHandler"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(poster)="data">
          <div style="width:120px;">
            <img :src="data.item.poster" style="width:120px;" />
          </div>
        </template>

        <template v-slot:cell(date)="data">
          <div
            style="width:150px; font-size:0.8rem; color:rgb(170,170,170)l display:block;"
          >
            <strong>
              {{ data.item.date }}
              <br />
              {{ data.item.time }}
            </strong>
          </div>
        </template>

        <template v-slot:cell(pro_name)="data">
          <div style="width:190px;">
            <h6>{{ data.item.pro_name }}</h6>
            <div class="text-grey">{{ data.item.e }}</div>
          </div>
        </template>

        <template v-slot:cell(action)="data">
          <vs-button @click="selectE(data.item)" color="primary" type="flat"
            >Select</vs-button
          >
        </template>
      </b-table>
    </div>
  </vs-popup>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";

export default {
  components: {},
  props: {
    showDialog: false,
    merchant: null
  },
  data: () => ({
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    s_list: [],
    e_main_list: [],
    e_upcoming_list: [],
    columns: [
      { label: "", key: "poster", sortable: false },
      { label: "", key: "pro_name", sortable: false },
      { label: "", key: "date", sortable: false }
    ],
    s: null,
    filter: null
  }),
  computed: {
    show: {
      get() {
        if (this.showDialog) {
          this.loadEvents(this.merchant);
        } else {
        }
        return this.showDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  watch: {},
  created() {},
  methods: {
    eventDataProvider(ctx, callback) {
      setTimeout(() => {
        let data = {
          s: this.merchant,
          page: this.currentPage,
          per_page: 1000
        };
        if (ctx.filter) {
          data["filter"] = ctx.filter;
        }
        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        this.upcoming = { total: 0, from: 0, to: this.perPage, page: 1 };
        this.previous = { total: 0, from: 0, to: this.perPage, page: 1 };
        Service.Event.my(params)
          .then(res => {
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;

            if (!res.data.child) {
              this.e_main_list = res.data.rows.filter(x => x.parent_id == null);
              this.e_upcoming_list = res.data.rows.filter(
                x => x.workshop_listing_status == 1
              );

              this.e_upcoming_list.concat(this.e_main_list);
            } else {
              this.e_main_list = res.data.rows;
              this.e_upcoming_list = res.data.child;
              this.e_upcoming_list.concat(this.e_main_list);
            }

            callback(this.e_upcoming_list);
          })
          .catch(error => {
            callback([]);
            //this.eventDataProvider(ctx, callback);
          });
      }, 800);
    },
    loadEvents(s, key = null) {
      let data = {
        s: s,
        page: 1
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();

      this.upcoming = { total: 0, from: 0, to: this.perPage, page: 1 };
      this.previous = { total: 0, from: 0, to: this.perPage, page: 1 };
      Service.Event.my(params)
        .then(res => {
          this.totalRows = res.data.total;
          this.from = res.data.from;
          this.to = res.data.to;

          // if (!res.data.child) {
          //   this.e_main_list = res.data.rows.filter(x => x.parent_id == null);
          //   this.e_upcoming_list = res.data.rows.filter(
          //     x => x.workshop_listing_status == 1
          //   );

          //   this.e_upcoming_list.concat(this.e_main_list);
          // } else {
          //   console.log(res.data);
          //   this.e_main_list = res.data.rows;
          //   this.e_upcoming_list = res.data.child;
          //   this.e_upcoming_list = this.e_upcoming_list.concat(res.data.rows);
          // }
          this.e_main_list = res.data.rows.filter(x => x.parent_id == null);
          this.e_upcoming_list = res.data.rows.filter(
            x => x.workshop_listing_status == 1
          );

          this.e_upcoming_list = this.e_upcoming_list.concat(this.e_main_list);

          this.$vs.loading.close();
        })
        .catch(error => {
          //callback([]);
        });
    },
    selectS(seller) {
      this.$vs.loading();
      Service.Auth.updateProfile({ s: seller.s }).then(res => {
        if (res.success) {
          this.$store.dispatch("Utility/setMerchant", res.data.default.s);
          this.$router.replace({ query: { s: res.data.default.s } });
          this.mode = "select_e";
          this.e_upcoming_list = [];
          setTimeout(() => {
            this.loadEvents(seller.s);
          }, 1000);
        }
        this.$vs.loading.close();
      });
    },
    selectE(event) {
      this.$vs.loading();
      Service.Auth.updateProfile({
        s: event.merchant.s,
        e: event.e
      })
        .then(res => {
          if (res.success) {
            Service.Event.get(event.e)
              .then(event => {
                let header = {
                  slug: event.data.event.slug,
                  title: event.data.event.pro_name,
                  excerpt: event.data.event.date,
                  image: event.data.event.merchant.logo,
                  action: "openEventList"
                };
                this.$store.dispatch("Utility/setHeader", header);
              })
              .catch(e => {
                /* this.$router.push("/pages/error-404").catch(() => {}); */
              });

            this.$store.dispatch("Utility/setMerchant", res.data.default.s);
            this.$store.dispatch("Utility/setEvent", res.data.default.e);

            this.$router.replace({
              name: "redirect",
              query: { s: res.data.default.s, e: res.data.default.e }
            });
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });

      this.$emit("close");
    },
    myRowClickHandler(record, index) {
      this.selectE(record);
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      // console.log(record); // This will be the item data for the row
    }
  }
};
</script>
<style lang="scss" scoped>
.hidden_header {
  display: none;
}
</style>
